<h1 mat-dialog-title>Registration successful!!</h1>
User : {{data.last_name}} {{data.first_name}}
<div mat-dialog-content>
  <p>Press OK to close!</p>
  <p>Or press this link to view Register Log : <A href="./register-log">Register Log</A></p>  
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">OK</button> 
</div>
